// o número dos relatórios acaba impactando na ordem (lexicográfica) em que eles aparecem no bunch-frontend,
// de acordo com o mongo (db.modules.find({"_id": "relatorios_operacionais"});)!
// leve isto em consideração para contribuir com a manutenibilidade do projeto!
export const RELATORIOS_ENUM = {
  EMPRESAS: 0,
  EMPRESAS_SITUACAO: 5,
  VEICULOS_FROTAS_SINTETICO: 9,
  VEICULOS_FROTAS_ANALITICO: 10,
  VISTORIAS: 20,
  LICENCAS: 30,
  SLIC_LINHAS: 40,
  SLIC_PERMISSIONARIOS: 41,
  STRIP_LINHAS: 50,
  STRIP_CONTRATOS: 51,
  STRIP_CONTRATOS_DOCUMENTOS: 52,
  SOLICITACOES: 90,
};
